import { useLang } from '@/lib/i18n';

interface TypingIndicatorProps {
  users: string[];
}

export function TypingIndicator({ users }: TypingIndicatorProps) {
  const { t } = useLang();

  if (users.length === 0) return null;

  let text = '';
  if (users.length === 1) {
    text = `${users[0]} ${t('typing.one')}`;
  } else if (users.length === 2) {
    text = `${users[0]} ${t('typing.two')} ${users[1]} ${t('typing.twoSuffix')}`;
  } else {
    text = t('typing.several');
  }

  return (
    <div className="flex items-center gap-2 px-2 py-1 h-6 w-full animate-in fade-in duration-300 slide-in-from-bottom-1">
      <div className="flex gap-1 items-center bg-card/60 backdrop-blur-md px-2 py-1 rounded-full border border-border/30">
        <div className="flex space-x-1">
          <div className="w-1.5 h-1.5 bg-muted-foreground/60 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="w-1.5 h-1.5 bg-muted-foreground/60 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="w-1.5 h-1.5 bg-muted-foreground/60 rounded-full animate-bounce"></div>
        </div>
        <span className="text-[11px] text-muted-foreground font-medium ml-1">
          {text}
        </span>
      </div>
    </div>
  );
}
